import { KLineData } from "klinecharts";
import { klineLineStyle, lineStyleToKLine } from "./lineStyle";
import { getPriceValue, readStyle } from "./indicatorUtils";

export const createRSI = (settings: any) => {
  const values = settings?.values ?? {};
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const period = (values.Period as number) ?? 14;
  const applyTo = (values["Apply to"] as string) ?? "Close";
  const rsiS = readStyle(styles, "rsi", "#B8860B");

  return {
    name: "rsi",
    shortName: `RSI${period}`,
    calcParams: [period, applyTo],
    series: "normal" as const,
    minValue: 0,
    maxValue: 100,
    figures: [{ key: "rsi", title: `RSI${period}: `, type: "line" }],
    styles: {
      lines: [klineLineStyle(rsiS.color, 2, lineStyleToKLine(rsiS.style))],
    },
    regenerateFigures: ([p]: number[]) => [
      { key: "rsi", title: `RSI${p}: `, type: "line" },
    ],
    calc: (dataList: KLineData[], indicator: { calcParams?: unknown[] }) => {
      const [p, priceField] = (indicator.calcParams ?? [period, applyTo]) as [
        number,
        string,
      ];
      const n = dataList.length;
      const results: Array<{ rsi?: number }> = new Array(n);
      results[0] = {};

      let gainAvg = 0;
      let lossAvg = 0;
      let seedG = 0;
      let seedL = 0;
      let seeded = false;

      for (let i = 1; i < n; i++) {
        const cur = getPriceValue(dataList[i]!, priceField);
        const prev = getPriceValue(dataList[i - 1]!, priceField);
        const d = cur - prev;
        const g = d > 0 ? d : 0;
        const l = d < 0 ? -d : 0;

        if (!seeded) {
          seedG += g;
          seedL += l;
          if (i === p) {
            gainAvg = seedG / p;
            lossAvg = seedL / p;
            seeded = true;
          } else {
            results[i] = {};
            continue;
          }
        } else {
          gainAvg = (gainAvg * (p - 1) + g) / p;
          lossAvg = (lossAvg * (p - 1) + l) / p;
        }

        if (lossAvg === 0) {
          results[i] = { rsi: gainAvg > 0 ? 100 : 50 };
        } else {
          const rs = gainAvg / lossAvg;
          results[i] = { rsi: 100 - 100 / (1 + rs) };
        }
      }

      return results;
    },
  };
};
